// Renders the toasts raised through lib/toast.js (aithlo-frontend#34, #35).
// Mounted once in App.jsx. Errors are announced assertively (role="alert"),
// everything else politely; each has a labelled close button, and a
// failure's backend reason sits under Details as FormError does.
import React, { useEffect, useState } from 'react';
import { CheckCircle2, AlertCircle, Info, X } from 'lucide-react';
import { dismiss, subscribe } from '../../lib/toast';
import { cn } from '../../lib/utils';

const STYLE = {
  success: { Icon: CheckCircle2, ring: 'border-accent-tint-border', icon: 'text-accent-default' },
  info: { Icon: Info, ring: 'border-border-default', icon: 'text-text-tertiary' },
  error: { Icon: AlertCircle, ring: 'border-status-danger', icon: 'text-status-danger' },
};

export function Toaster() {
  const [items, setItems] = useState([]);
  useEffect(() => subscribe(setItems), []);
  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-[calc(var(--mobile-nav-h)+0.75rem)] z-[10030] flex flex-col items-center gap-2 px-4 md:bottom-6 md:items-end md:px-6">
      {items.map((t) => {
        const s = STYLE[t.variant] || STYLE.info;
        return (
          <div key={t.id} role={t.variant === 'error' ? 'alert' : 'status'}
            className={cn('pointer-events-auto flex w-full max-w-sm items-start gap-3 rounded-xl border bg-bg-surface p-3 text-sm text-text-primary shadow-lg', s.ring)}>
            <s.Icon size={18} className={cn('mt-0.5 shrink-0', s.icon)} aria-hidden="true" />
            <div className="min-w-0 flex-1">
              <p className="m-0 leading-snug">{t.text}</p>
              {t.details && (
                <details className="mt-1 text-xs text-text-tertiary">
                  <summary className="cursor-pointer select-none">Details</summary>
                  <span className="break-words">{t.details}</span>
                </details>
              )}
            </div>
            <button type="button" aria-label="Dismiss" onClick={() => dismiss(t.id)}
              className="-m-1 rounded p-1 text-text-tertiary hover:bg-bg-raised hover:text-text-secondary">
              <X size={14} />
            </button>
          </div>
        );
      })}
    </div>
  );
}

export default Toaster;
